import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { UserDetails } from '../classes/userDetails';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // Initialize
  constructor(private http: HttpClient) { }

  public login(userDetails: UserDetails): any {
    // this.Products = this.http.get<Product[]>('assets/data/products.json').pipe(map(data => data));
    // this.Products.subscribe(next => { localStorage['products'] = JSON.stringify(next) });
    // return this.Products = this.Products.pipe(startWith(JSON.parse(localStorage['products'] || '[]')));
    return this.http.post(`${environment.apiUrl}/api/Auth`, userDetails) as Observable<any>;

  }

}